<!--
  A full-width text content block with huge, hero text.
-->
<template>
  <div :class="[{'text-center': centered}, brandService.getName() === Brand.HIS ? 'text-brand-secondary' : 'text-black' ]" class="text-black">
    <div :class="brandService.getName() === Brand.HIS ? 'font-gotham-bold' : 'font-extrabold'" class="leading-none text-2xl md:text-3xl lg:text-5xl tracking-tight">{{ title }}</div>
    <div v-if="subtitle" class="text-md md:text-xl max-w-2xl text-gray-500 font-light" v-html="subtitle"></div>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
import { Brand } from '../../services/integration/enums';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

defineProps<{
  title: string,
  subtitle?: string,
  centered?: boolean
}>();
</script>
